



































import axios, { AxiosError } from 'axios';
import { ValidationObserver } from 'vee-validate';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/common/Loading.vue';

interface PdfUploadRes {
  uuid: string;
  pageCount: number;
  fileName: string;
}

@Component({
  components: {
    Loading,
    ValidationObserver,
  },
})
export default class PdfPage extends Vue {
  private title: string | null = null;
  private text: string | null = null;
  private loading = false;

  private async created() {
    if (this.$route.query.messageId != null) {
      this.loading = true;
      const res = await axios
        .get('/api/receive_mail/info', {
          params: {
            messageId: this.$route.query.messageId,
          },
        })
        .catch((error: AxiosError) => {
          console.error(error);
          return null;
        });
      this.loading = false;
      if (res != null) {
        this.title = res.data.subject;
        this.text = res.data.body;
      }
    }
  }

  private async makePdf() {
    this.loading = true;
    const res = await axios
      .post(`/api/pdf/text`, {
        title: this.title,
        text: this.text,
      })
      .catch((error: AxiosError) => {
        console.error(error);
        return null;
      });
    this.loading = false;
    if (res?.data.uuid) {
      this.$router.push({
        name: 'pdf',
        query: {
          id: res.data.uuid,
        },
      });
    } else {
      // TODO: どの文字が不正かなど、詳しいエラー情報を表示したい
      this.$toast.error('不正な文字が含まれています。');
    }
  }
}
